import { isNil } from "lodash";
import { useEffect, useState } from "react";
import { useHomeUsePluginContainer } from "../../../custom-hooks/HomeUsePluginRoot";
import { AI_POP_UP, TRY_AUTO_IMAGICA } from "./constants";

let hasBeenOpened = false;

export const useRetryPopover = (showCot: boolean, enableCOTStartAgain: string) => {
  const [open, setOpen] = useState<boolean | undefined>(false);
  const [popContent, setPopContent] = useState<string>();
  const {
    guideTriggerMessageState: { imagicaStudioTutorial },
  } = useHomeUsePluginContainer();

  const openPopover = (content: string) => {
    setPopContent(content);
    setOpen(true);
    hasBeenOpened = true;
    setTimeout(() => {
      setOpen(undefined);
    }, 3000);
  };

  useEffect(() => {
    if (imagicaStudioTutorial.showCotGuide === false && showCot === false) {
      openPopover(TRY_AUTO_IMAGICA);
    }
    if (hasBeenOpened === false && showCot === false && isNil(enableCOTStartAgain) === false) {
      openPopover(AI_POP_UP);
    }

    if (isNil(enableCOTStartAgain) === true) {
      hasBeenOpened = false;
    }
  }, [showCot, enableCOTStartAgain, imagicaStudioTutorial.showCotGuide]);

  return { open, popContent };
};
